import script from "./AdminPaidDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminPaidDialog.vue?vue&type=script&setup=true&lang=js"

import "./AdminPaidDialog.vue?vue&type=style&index=0&id=770d5dec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-770d5dec"]])

export default __exports__